import { Injectable } from '@angular/core';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { NodeInspectorRegistry } from '@shared/state/node-inspector-registry.service';
import { ExperimentInspectorComponent } from '@shared/components/joint-js/components/inspectors/experiment-inspector/experiment-inspector.component';
import { OfferPaymentAgreementInspectorComponent } from '@shared/components/joint-js/components/inspectors/offer-payment-agreement-inspector/offer-payment-agreement-inspector.component';

@Injectable({ providedIn: 'root' })
export class NodeInspectorRegistrar {
  constructor(registry: NodeInspectorRegistry) {
    registry.register(NodeType.Experiment, ExperimentInspectorComponent);
    registry.register(NodeType.OfferPaymentAgreement, OfferPaymentAgreementInspectorComponent);

    // register other node inspectors here:
    // registry.register(NodeType.Email, EmailInspectorComponent);
    // registry.register(NodeType.SMS, SmsInspectorComponent);
    // ...
  }
}
